export const maxDaysDifference = 7;

export const ClientSearchFilterType = Object.freeze({
  connected: 'connected',
  recentlyAdded: 'recentlyAdded',
  notConnected: 'notConnected',
});

export const ClientSearchFilterTypeLabel = Object.freeze({
  [ClientSearchFilterType.connected]: 'Connected',
  [ClientSearchFilterType.recentlyAdded]: `Added in last ${maxDaysDifference} days`,
  [ClientSearchFilterType.notConnected]: 'Not Connected',
});

export const ClientMonitorSearchFilterType = Object.freeze({
  allClients: 'allClients',
  recentlyAdded: 'recentlyAdded',
  notConnected: 'notConnected',
  connected: 'connected',
  unassignedClients: 'unassignedClients',
});

export const ClientMonitorSearchFilterTypeLabel = Object.freeze({
  [ClientMonitorSearchFilterType.allClients]: 'All clients',
  [ClientMonitorSearchFilterType.recentlyAdded]: 'Recently added',
  [ClientMonitorSearchFilterType.connected]: 'Connected',
  [ClientMonitorSearchFilterType.notConnected]: 'Not connected',
  [ClientMonitorSearchFilterType.unassignedClients]: 'Unassigned clients',
});
